<template>
  <IQOS :title="$t('marketplace.loyalty')" :readonly="editing">
    <p
      class="comment pt-0 c-white">
      {{$t('marketplace.bonus_hint')}}
    </p>
    <!-- <p class="comment c-grey">
        {{$t('marketplace.bonus_amount')}}:
    </p> -->
    <BlackSelect 
        class="cashback-input" v-model="loyalty.cashback_percent" :readonly="!editing">
      <option :value="null">{{$t('marketplace.no_bonus')}}</option>
      <option :value="1">1%</option>
      <option :value="2">2%</option>
      <option :value="3">3%</option>
      <option :value="4">4%</option>
      <option :value="5">5%</option>
    </BlackSelect>
    <!-- <p
      class="comment c-grey"
    >{{$t('marketplace.loyalty_program')}}</p> -->

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";

import RoundCheckbox from "@/components/RoundCheckbox.vue";

export default {
  data() {
    return {
      editing: false,

      loyalty: {
        cashback_percent: null,
        terms_agreed: false
      }
    };
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    BlackSelect,
    RoundCheckbox
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialValue();
    },
    onEditFinish() {
      if (this.loyalty.cashback_percent) {
        this.loyalty.terms_agreed = true;
      }
      this.$store.commit("setLoyaltySettings", this.loyalty);
      this.$store.dispatch("saveCafe");

      this.editing = false;

      this.$store.dispatch('auditlog/write', {
        type: 'loyalty_change',
        payload: {
          percent: this.loyalty.cashback_percent
        }
      })
    },
    setInitialValue() {
      if (this.cafe.loyalty) {
        this.loyalty.terms_agreed = !!this.cafe.loyalty.cashback_percent;
        this.loyalty.cashback_percent = this.cafe.loyalty.cashback_percent;
      }
    }
  },
  mounted() {
    this.setInitialValue();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  }
};
</script>

<style scoped>
.cashback-input {
  width: 100%;
  margin-top: 1vh;

  text-align-last: center;
}

 

 
 
</style>